import React from 'react';
import Markdown from 'react-markdown';
import Link from 'next/link';

type MarkdownLinkProps = { text: string; styles?: string };

export default function MarkdownLink({ text, styles }: MarkdownLinkProps) {
  return (
    <Markdown
      components={{
        ul: ({ children }) => <ul className={styles}>{children}</ul>,
        li: ({ children }) => (
          <li className="flex items-center gap-2 text-nowrap">{children}</li>
        ),
        a: ({ href, children }) =>
          href?.startsWith('/') ? (
            <Link href={href} className={`${styles} font-montserrat`}>
              {children}
            </Link>
          ) : (
            <a
              href={href}
              className={`${styles} font-montserrat`}
              target="_blank"
            >
              {children}
            </a>
          ),
      }}
    >
      {text}
    </Markdown>
  );
}
